(function () {
    'use strict';

    angular
        .module('app.tenants')
        .run(appRun);

    appRun.$inject = ['routerHelper', 'opsIncludeVersion'];
    /* @ngInject */
    function appRun(routerHelper, opsIncludeVersion) {
        routerHelper.configureStates(getStates(opsIncludeVersion));
    }

    function getStates(opsIncludeVersion) {
        return [
              {
                  state: 'tenants',
                  config: {
                      abstract: true,
                      url: '/tenants',
                      template: '<ui-view/>',
                      settings: {
                          authMode: 1
                      },
                      resolve: {
                          authenticationRequired: ['userService', function (userService) {
                              if (userService.tenantId() != "1") {
                                  throw { name: "NotAdmin" };
                              }
                          }]
                      }
                  }
              },
            {
                state: 'tenants.list',
                config: {
                    url: '/list',
                    templateUrl: 'app/tenants/list.html?v=' + opsIncludeVersion,
                    controller: 'TenantsListController',
                    controllerAs: 'vm',
                    title: 'Tenants'
                }
            },
            {
             state: 'tenants.details',
             config: {
                 url: '/detail/:id',
                 templateUrl: 'app/tenants/details.html?v=' + opsIncludeVersion,
                 controller: 'TenantDetailsController',
                 controllerAs: 'vm',
                 title: 'Tenant Details',
                 settings: {}
             }
            }
          
        ];
    }
})();
